import React from "react";

import { Link } from "react-router-dom";
export default function Services() {
  return (
    <>
      <section className="layout-pt-sm layout-pb-lg bg-white">
        <div className="container">
          <div className="row y-gap-50 text-dark-1 justify-between items-center">
            {/* <div className="col-lg-6 pr-50 sm:pr-15">
              <div className="composition -type-8">
                <div className="-el-1">
                  <img src="/assets/img/about-1/1.png" alt="image" />
                </div>
                <div className="-el-2">
                  <img src="/assets/img/about-1/2.png" alt="image" />
                </div>
                <div className="-el-3">
                  <img src="/assets/img/about-1/3.png" alt="image" />
                </div>
              </div>
            </div> */}

            <div className="col-lg-12">
              <h2 className="text-30 lh-16">Services we offer</h2>
              <p className="text-15 mt-30">
                <h3>📚 Books & Study Materials</h3>
                <ul>
                  <li>
                    100% syllabus coverage for RRB Pharmacist, TSPSC, ESIC,
                    AIIMS, CGHS, ARMY, and Drug Inspector exams.
                  </li>
                  <li>
                    Topic-wise theory & MCQs with justifications for better
                    understanding.
                  </li>
                  <li>
                    Fully solved previous year papers for real exam practice.
                  </li>
                </ul>
              </p>

              <p className=" mt-30">
                <h3>💻 Online Learning & Digital Content</h3>
                <ul>
                  <li>Live & recorded video lectures by expert faculty.</li>
                  <li>
                    Exclusive digital content – Free PDFs, study notes, and mock
                    tests.
                  </li>
                  <li>
                    QR-code enabled book-based learning for interactive study.
                  </li>
                </ul>
              </p>

              <p className=" mt-30">
                <h3>🎯 Mock Tests & Exam Simulations</h3>
                <ul>
                  <li>
                    Full-length mock tests replicating real exam scenarios.
                  </li>
                  <li>
                    Subject-wise & topic-wise tests for targeted revision.
                  </li>
                  <li>
                    Performance analysis to track progress and improve accuracy.
                  </li>
                </ul>
              </p>

              <p className=" mt-30">
                <h3>🏆 Rank-Oriented Coaching</h3>
                <ul>
                  <li>
                    Expert guidance for GPAT, NIPER, PGCET, TSPSC, RRB, and Drug
                    Inspector exams.
                  </li>
                  <li>
                    Online & offline coaching with structured study plans.
                  </li>
                  <li>Personalized mentorship & doubt-solving sessions.</li>
                </ul>
              </p>

              <p className=" mt-30">
                <h3>💡 Flexible Learning & Affordable Pricing</h3>
                <ul>
                  <li>
                    Book-Based Online Coaching – Students can pay only for the
                    topics they need, making learning cost-effective.
                  </li>
                  <li>Affordable course fees with multiple payment options.</li>
                  <li>
                    Lifetime access to digital content for continued revision.
                  </li>
                </ul>
              </p>
              <div className="d-inline-block">
                <Link
                  to="/login"
                  className="button -md -black text-white mt-30"
                >
                  Start Learning
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
